import { render, staticRenderFns } from "./dashboardSummaries.vue?vue&type=template&id=16d520e3&scoped=true&"
import script from "./dashboardSummaries.vue?vue&type=script&lang=js&"
export * from "./dashboardSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d520e3",
  null
  
)

export default component.exports